var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-in"},[_c('div',{staticClass:"form-box has-text-centered"},[_c('h3',[_vm._v("You have been signed out.")]),_c('router-link',{staticClass:"button is-dark",attrs:{"to":"/"}},[_vm._v("Return to Homepage")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }